<footer class="footer">
  <div class="container">
    <div class="footer__top">
      <div class="footer__brand">
        <a [routerLink]="getLocalizedRoute('/')" class="footer__logo">
          <img src="assets/img/logo.svg" alt="{{ 'app.title' | transloco }}" />
        </a>
      </div>

      <div class="footer__columns">
        <div class="footer__column">
          <h4 class="footer__column-title">{{ 'footer.product' | transloco }}</h4>
          <ul>
            <li><a [routerLink]="getLocalizedRoute('/')">{{ 'nav.findJobs' | transloco }}</a></li>
            <li><a [routerLink]="getLocalizedRoute('/companies')">{{ 'nav.companies' | transloco }}</a></li>
            <li><a [routerLink]="getLocalizedRoute('/market-analytics')">{{ 'nav.marketAnalytics' | transloco }}</a></li>
            <li><a [routerLink]="getLocalizedRoute('/market-predictions')">{{ 'nav.marketPredictions' | transloco }}</a></li>
          </ul>
        </div>

        <div class="footer__column">
          <h4 class="footer__column-title">{{ 'footer.account' | transloco }}</h4>
          <ul>
            <li><a [routerLink]="getLocalizedRoute('/login')">{{ 'nav.login' | transloco }}</a></li>
            <li><a [routerLink]="getLocalizedRoute('/register')">{{ 'nav.register' | transloco }}</a></li>
          </ul>
        </div>

        <div class="footer__column">
          <h4 class="footer__column-title">{{ 'footer.legal' | transloco }}</h4>
          <ul>
            <li><a [routerLink]="getLocalizedRoute('/privacy-policy')">{{ 'footer.privacyPolicy' | transloco }}</a></li>
            <li><a [routerLink]="getLocalizedRoute('/terms-of-use')">{{ 'footer.termsOfUse' | transloco }}</a></li>
            <li><a [routerLink]="getLocalizedRoute('/subprocessors')">{{ 'footer.subprocessors' | transloco }}</a></li>
          </ul>
        </div>

        <div class="footer__column">
          <h4 class="footer__column-title">{{ 'footer.contact' | transloco }}</h4>
          <ul>
            <li><a href="mailto:info@sameta.sk">info&#64;sameta.sk</a></li>
            <li class="footer__company-info">{{ 'app.legalName' | transloco }}</li>
          </ul>
        </div>
      </div>
    </div>

    <div class="footer__eu-funding">
      <img src="assets/img/eu-nextgen.png" alt="Financované Európskou úniou – NextGenerationEU" loading="lazy" />
      <img src="assets/img/plan-obnovy.png" alt="Plán obnovy" loading="lazy" />
      <img src="assets/img/uvsr.png" alt="Úrad podpredsedu vlády SR pre plán obnovy a znalostnú ekonomiku" loading="lazy" />
    </div>

    <p class="footer__copyright">&copy; {{ currentYear }} {{ 'app.legalName' | transloco }}. {{ 'footer.allRightsReserved' | transloco }}</p>
  </div>
</footer>
